import { useForm } from "react-hook-form";
import { IDENTITY_UPLOAD_ROUTE } from "@api-routes";
import { useFetch } from "@common/hook/useFetch";

export const useUploadIdentityDocument = (callback: () => void) => {
    const [uploadIdentityDocumentState, { post }] = useFetch();
    const formMethods = useForm<{ frontBase64: string; backBase64: string; type: string }>({
        defaultValues: { frontBase64: "", backBase64: "", type: "" },
    });

    const { handleSubmit } = formMethods;

    const handleOnSubmit = handleSubmit((formData) => {
        post<boolean>(IDENTITY_UPLOAD_ROUTE, {
            body: { frontBase64: formData.frontBase64, backBase64: formData.backBase64, type: formData.type },
        }).then((uploadIdentityDocumentResponse) => {
            if (uploadIdentityDocumentResponse) {
                callback();
            }
        });
    });

    return { formMethods, handleOnSubmit, uploadIdentityDocumentState };
};
